import React from 'react';

const OrderItems = ({ items, language }) => {
    if (!items || items.length === 0) return null;

    return (
        <div className="mt-4">
            <h3 className="text-sm font-medium text-gray-700 mb-2">
                {language === 'ar' ? 'المنتجات:' : 'Items:'}
            </h3>
            <div className="space-y-2 max-h-40 overflow-y-auto">
                {items.map((item, index) => (
                    <div key={index} className="flex justify-between text-sm">
                        <span>{item.name}</span>
                        <span className="text-gray-600">
                            {item.quantity} x {item.price?.toFixed(2) || '0.00'}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OrderItems;
